module.exports = __webpack_public_path__ + "static/media/city-elements-facilities-14-svgrepo-com.1053cc44.svg";